module.exports = __webpack_public_path__ + "static/img/03-01.72b430c4.png";